module.exports = __webpack_public_path__ + "img/Trustpilot_ratings_1star-RGB.5a49f230.svg";